import { tenantQuery } from "@common/api"
import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, Outlet } from "@tanstack/react-router"
import { PageContent, PageTitle } from "@/components/page/page-content"
import { requireSystemUser } from "@/lib/require-system-user"
import { TenantEditTabs } from "./-components/tenant-edit-tabs"

export const Route = createFileRoute(
  "/_layout/settings/system_/tenants/$tenantId",
)({
  beforeLoad: ({ context: { queryClient } }) =>
    requireSystemUser(queryClient, "/settings/system"),
  loader: async ({ context: { queryClient }, params: { tenantId } }) => {
    const tenant = await queryClient.ensureQueryData(
      tenantQuery({ tenant_id: tenantId }),
    )
    return {
      breadcrumb: [
        { label: "System Settings", href: "/settings/system" },
        { label: tenant.name, href: `/settings/system/tenants/${tenantId}` },
      ],
    }
  },
  component: TenantEditLayout,
})

function TenantEditLayout() {
  const { tenantId } = Route.useParams()
  const { data: tenant } = useSuspenseQuery(
    tenantQuery({ tenant_id: tenantId }),
  )

  return (
    <PageContent width="full">
      <PageTitle title={tenant.name} description="Setting up this tenant." />
      <TenantEditTabs tenantId={tenantId} />
      <Outlet />
    </PageContent>
  )
}
